
// @ts-nocheck
/* eslint-disable */
import {
  defineComponent,
  computed,
  ref
} from 'vue'
import { Overlay } from '@/components/overlay'
import { useDialog } from '@/components/dialog-v2'
import { TrapFocus } from '@/components/directives'

import type { PropType, SetupContext } from 'vue'

type Hide = (cancel: boolean) => void
type DrawerDirection = 'ltr' | 'rtl' | 'ttb' | 'btt'

export default defineComponent({
  name: 'MsDrawer',
  components: {
    [Overlay.name]: Overlay
  },
  directives: {
    TrapFocus
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    beforeClose: Function as PropType<(hide: Hide) => void>,
    customClass: {
      type: String,
      default: ''
    },
    direction: {
      type: String as PropType<DrawerDirection>,
      default: 'rtl',
      validator: (val: DrawerDirection) => {
        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1
      }
    },
    showClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: [String, Number],
      default: '30%'
    },
    title: {
      type: String,
      default: ''
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    openDelay: {
      type: Number,
      default: 0
    },
    closeDelay: {
      type: Number,
      default: 0
    },
    zIndex: Number,
    modal: {
      type: Boolean,
      default: true
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: String,
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    }
  },

  emits: ['open', 'opened', 'close', 'closed', 'update:modelValue'],

  setup (props, ctx) {
    const drawerRef = ref<HTMLElement>(null)
    return {
      ...useDialog(props, ctx as SetupContext, drawerRef),
      drawerRef,
      isHorizontal: computed(() => props.direction === 'rtl' || props.direction === 'ltr'),
      drawerSize: computed(() => typeof props.size === 'number' ? `${props.size}px` : props.size)
    }
  }
})
